'use strict';

/* Views */
import Main from './main.component';

/* Components */
import CarouselMain from '../../components/carousel-main/carouselMain.component';

export default angular.module('conduuApp.main', [Main, CarouselMain])
  .name;



// WEBPACK FOOTER //
// ./client/app/main/index.js